import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ComboDetails } from 'src/app/models/commission/combo-details.model';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { CommissionService } from 'src/app/service/commission.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-add-adjustments',
  templateUrl: './add-adjustments.component.html',
  styleUrls: ['./add-adjustments.component.css']
})
export class AddAdjustmentsComponent implements OnInit {

  public komFeedModel = new KomFeed();
  public oolDetails: KomFeed[] = [];
  public header: string = 'Add KOM Feed';
  public flags: string[] = ['Y', 'N'];

  public comboDtl = new ComboDetails();
  public products: ComboDetails[] = [];
  public productInfo: ComboDetails[] = [];
  public IsmodelShow: boolean = false;
  public controlStr = new FormControl();
  public existingOolCurrProducts: ComboDetails[] = [];
  public existingOolPrevProducts: ComboDetails[] = [];
  public actions: any;
  public actionButtons: any;
  public buttons: Buttons[] = [];
  public filteredCommStrValues: Observable<ComboDetails[]> | undefined;
  public field: string;
  public ordersTableColumns: TableColumn[];
  public columnsData: any;
  public isStatus: string = "";
  public resHeadder: string = 'KOM Feed Results';
  public multicombo: ComboDetails[] = [];
  public comboDtlAdd = new ComboDetails();
  public check: boolean = true;
  public translateMasterdata: KomFeed[] = [];

  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService,
    private notificationService: NotificationService, private router: Router, private httpService: HttpClient) { }

  ngOnInit(): void {
    this.komFeedModel.curr_ool_combo_str = "0";
    this.komFeedModel.prev_ool_combo_str = "0";
    this.komFeedModel.curr_misc_combo_str = "0";
    this.komFeedModel.prev_misc_combo_str = "0";
    this.komFeedModel.curr_ov_combo_str = "0";
    this.komFeedModel.prev_ov_combo_str = "0";
    

    this.comboDtl.position;
    console.log(this.comboDtlAdd);
    this.multicombo.push(this.comboDtlAdd);
    this.getOOLDetails();
    this.getAdminConfigTurfData();
  }

  getAdminConfigTurfData() {
    this.komFeedService.getAdminConfigTurfData()
      .subscribe((data: KomFeed[]) => {
        this.translateMasterdata = data;
        console.log(this.translateMasterdata);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  addAdjustment() {

    this.komFeedModel.komfeedid = 0;
    this.komFeedModel.id = 0;

    console.log(this.komFeedModel);

    if (this.komFeedModel.corp === null || this.komFeedModel.cust === null ||  this.komFeedModel.sales_rep_id === null || this.komFeedModel.house === null ||
      this.komFeedModel.recurring_rev === null ||
      this.komFeedModel.io_add_flag === null ||
      this.komFeedModel.wordate === null ||
      this.komFeedModel.wfindate === null ||
      this.komFeedModel.wddate === null ||
      this.komFeedModel.net_prem_chanels === null ||
      this.komFeedModel.net_ool === null ||
      this.komFeedModel.curr_product_class_id === null ||
      this.komFeedModel.prev_product_class_id === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please select all mandatory fields");
    } else {
      this.komFeedModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.komFeedModel.created_dt = new Date();
      this.komFeedModel.sales_rep_id = this.komFeedModel.sales_rep_id;

      console.log(this.komFeedModel);
      this.komFeedService.addAdjustment(this.komFeedModel).subscribe(
        (response: CustomHttpRespone) => {
          console.log(response);
          this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully");
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }

  }

  public getOOLDetails() {
    this.komFeedService.getOOLDetails()
      .subscribe((response: any) => {
        this.oolDetails = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  back() {
    this.router.navigate(['/feed-results']);
  }

  public viewOolCurrent(type: string, field: string) {
    this.existingOolCurrProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field
    if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.komFeedModel.curr_ool_combo_str?.length > 0) {
      for (let i = 0; i < this.komFeedModel.curr_ool_combo_str?.length; i++) {
        if (this.komFeedModel.curr_ool_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.curr_ool_combo_str[i]
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              if (response.productName != null)
                this.existingOolCurrProducts.push(response)
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }
      console.log(this.existingOolCurrProducts);
    }



    console.log(this.komFeedModel);
    this.komFeedService.getProductNames(this.komFeedModel).subscribe(
      (response: ComboDetails[]) => {
        this.products = response;
        console.log(this.products);
        this.filterCommStr();
        //console.log(response);
        document.getElementById('viewOolCurr').click();
        //this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public viewOolPrev(type: string, field: string) {
    this.existingOolPrevProducts = [];
    this.komFeedModel.svcsType = type;
    this.comboDtl.type = type;
    this.comboDtl.corp = this.komFeedModel.corp;
    this.comboDtl.wfinDate = this.komFeedModel.wfindate;
    this.field = field
    if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.komFeedModel.prev_ool_combo_str?.length > 0) {
      for (let i = 0; i < this.komFeedModel.prev_ool_combo_str?.length; i++) {
        if (this.komFeedModel.prev_ool_combo_str[i] != '0') {
          this.comboDtl.position = i + 1;
          this.comboDtl.currentValue = this.komFeedModel.prev_ool_combo_str[i]
          this.komFeedService.getProduct(this.comboDtl).subscribe(
            (response: ComboDetails) => {
              if (response.productName != null)
                this.existingOolPrevProducts.push(response)
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      }
      console.log(this.existingOolPrevProducts);
    }



    console.log(this.komFeedModel);
    this.komFeedService.getProductNames(this.komFeedModel).subscribe(
      (response: ComboDetails[]) => {
        this.products = response;
        this.filterCommStr();
        console.log(response);
        document.getElementById('viewOolPrev').click();
        //this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  filterCommStr() {
    this.filteredCommStrValues = this.controlStr.valueChanges.pipe(
      startWith(''),
      map(value => this._filterStr(value))
    );
  }
  private _filterStr(value: string): ComboDetails[] {
    const filterValue = this._normalizeValue(value);
    return this.products.filter(item => this._normalizeValue(item.productName).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toString().toLowerCase().replace(/\s/g, '');
  }

  getCommPlan(kpiForm: NgForm, i: number) {
    console.log(this.multicombo)
    // kpiForm.reset();
    const comboNew = new ComboDetails()
    this.check = true;
    this.komFeedModel.productName = this.multicombo[i].productName;
    this.komFeedService.getProductInfo1(this.komFeedModel).subscribe(
      (response: ComboDetails[]) => {
        this.productInfo = response;
        if (this.productInfo.length === 1) {
          this.comboDtl = this.productInfo[0];
          this.multicombo[i].position = this.comboDtl.position;
          if (!this.comboDtl.position || !this.comboDtl.newValue) {
            this.notificationService.sendNotification(NotificationType.WARNING, "The Product is not having postion & Value Select other Product");
          } else if (this.multicombo.length > 1) {
            for (let mcomb of this.multicombo) {
              if (mcomb.position === this.comboDtl.position &&
                mcomb.productName != this.comboDtl.productName) {
                // this.notificationService.sendNotification(NotificationType.WARNING, "Dupppppppp & Value Select other Product");
                if (confirm("For the same Postion " + mcomb.productName + "is mapped Do you want override?"))
                  this.check = true;
                else
                  this.check = false;
              }
            }
          }
          if (this.check) {
            this.multicombo.push(comboNew);
            this.modifyCombo();
          }
        } else if (this.productInfo.length > 1) {
          this.notificationService.sendNotification(NotificationType.WARNING, "The Product is having multipule Postion & Values select other Product");
        } else if (this.productInfo.length === 0) {
          this.notificationService.sendNotification(NotificationType.WARNING, "The Product is not having  Postion & Values select other Product");
        } else {
          if (this.komFeedModel.svcsType === 'ool addnl svcs%')
            this.comboDtl.currentValue = this.komFeedModel.curr_ool_combo_str[this.comboDtl.position]
          else if (this.komFeedModel.svcsType === 'ool addnl svcs%')
            this.comboDtl.currentValue = this.komFeedModel.curr_ool_combo_str[this.comboDtl.position]
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
    // if(event.source.selected)
  }

  modifyCombo() {
    if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'current') {
      this.komFeedModel.curr_ool_combo_str = this.komFeedModel.curr_ool_combo_str.substring(0, this.comboDtl.position - 1) +
        this.comboDtl.newValue + this.komFeedModel.curr_ool_combo_str.substring(this.comboDtl.position);
    } else if (this.komFeedModel.svcsType === 'ool addnl svcs%' && this.field === 'prev') {
      this.komFeedModel.prev_ool_combo_str = this.komFeedModel.prev_ool_combo_str.substring(0, this.comboDtl.position) +
        this.comboDtl.newValue + this.komFeedModel.prev_ool_combo_str.substring(this.comboDtl.position + 1);
    }
    //this.close(kpiForm, 'closeAddKPIButton');
  }

  close(kpiForm: NgForm, id: string) {
    this.multicombo = [];
    this.multicombo.push(this.comboDtlAdd);
    kpiForm.reset();
    document.getElementById(id).click();
  }

  public save(comboForm: NgForm) {
    this.update();
    this.close(comboForm, 'closeAddKPIButton');
  }

  public update() {
    console.log("update Called");
    this.komFeedService.updateKomFeedByID(this.komFeedModel).subscribe(
      (response: CustomHttpRespone) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  deleteOolCurr(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log('Delete', product);
    this.komFeedModel.curr_ool_combo_str = this.komFeedModel.curr_ool_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.curr_ool_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    if (value === 'existing')
      this.existingOolCurrProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);

  }

  deleteOolPrev(product: ComboDetails, kpiForm: NgForm, i: any, value: string) {
    console.log('Delete', product);
    this.komFeedModel.prev_ool_combo_str = this.komFeedModel.prev_ool_combo_str.substring(0, product.position - 1) +
      0 + this.komFeedModel.prev_ool_combo_str.substring(product.position);
    // this.close(kpiForm, 'closeAddKPIButton');
    if (value === 'existing')
      this.existingOolPrevProducts.splice(i, 1);
    else
      this.multicombo.splice(i, 1);

  }

}
